/**
 * Where the CMS lives, for the few assets still served from it directly.
 *
 * Its own module so the value is a setting rather than a literal buried in a
 * component. Only the app-info illustrations need it: everything else the CMS
 * holds is mirrored to object storage by the backend's media sync and addressed
 * through `/api`.
 */
export function cmsUrl(): string {
  return process.env.NEXT_PUBLIC_CMS_URL || "https://cms.mappr.xyz";
}
